import React from 'react';
import ReviewListItem from './ReviewListItem';

/**
 * List of reviews; user selects one to view images.
 */
function ReviewList({ reviews, selectedReviewId, onSelectReview }) {
  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Wybierz opinię</h2>
      <div
        className="space-y-2 max-h-[600px] overflow-y-auto"
        role="list"
        aria-label="Lista opinii"
      >
        {reviews.map((review) => (
          <ReviewListItem
            key={review.id}
            review={review}
            isSelected={selectedReviewId === review.id}
            onSelect={onSelectReview}
          />
        ))}
      </div>
    </div>
  );
}

export default ReviewList;
